import { render, staticRenderFns } from "./TicketFinancialsTable.vue?vue&type=template&id=020c9408&"
import script from "./TicketFinancialsTable.vue?vue&type=script&lang=js&"
export * from "./TicketFinancialsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports